<div (click)="goToConfigurator()" class="img">
  <img [src]="waterBottle.image_url">
</div>
<div (click)="goToConfigurator()" class="cell-title">
  {{ name }}
</div>
<div (click)="goToConfigurator()" class="cell-subtitle" ellipsis [innerHTML]="description" (ellipsis-click-more)="moreClicked($event)">
</div>
<div class="cell-separator" [ngClass]="{'is-hidden': isSeparatorHidden}"></div>
